<template>
  <div class="grid-wrapper">
    <v-card
      v-for="group in groups"
      :key="group.title">

      <v-card-title>
        <h3>{{ group.title }}</h3>
      </v-card-title>

      <v-card-text>
        <dl>
          <template v-for="(detail, index) in group.details">
            <dt :key="`title-${index}-${detail.title}`" :class="[detail.class]">
              {{ detail.title || "" }}
            </dt>
            <dd :key="`text-${index}-${detail.text}`" :class="[detail.class]">
              {{ detail.text || "" }}
            </dd>
          </template>
        </dl>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
export default {
  name: 'MatchDetailTableGroup',
  props: {
    deal: Object,
  },
  computed: {
    groups () {
      const currencyFilter = this.$options.filters.currency
      const deal = this.deal

      return [
        {
          title: 'Deal Details:',
          details: [
            {
              title: 'Type of Deal',
              text: deal.dealType[0],
            },
            ...deal.dealType.slice(1).map(text => ({
              title: '',
              text,
              class: 'same-group',
            })),

            { title: 'Credit Score', text: deal.creditScore },
            { title: 'Size of Deal', text: currencyFilter(deal.dealSize) },
          ],
        },
        {
          title: 'Loan Details',
          details: [
            {
              title: 'Loan Type',
              text: (deal.loanType || 'No Preference'),
            },
            {
              title: 'Payback terms',
              text: (deal.loanPaymentTerms || 'Undecided / No Preference'),
            },
            { title: 'Close Date', text: deal.speedOfClosing },
          ],
        },
        {
          title: 'Selected Features',
          details: deal.lenderFeatures && deal.lenderFeatures.length
            ? deal.lenderFeatures.map(feature => ({ title: '', text: feature }))
            : [{ text: 'None Selected' }],
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.grid-wrapper {
  margin-top: 10px;
  margin-bottom: 20px;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto auto;

  grid-column-gap: 30px;
  grid-row-gap: 30px;

  @include lg {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }
}

.v-card {
  padding: 0;
  border: none;
  box-shadow: none;

  .v-card__title {
    background-color: #e5f7f8;
    color: #4e4e4e;
  }

  .v-card__text dl {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: 1fr;

    padding: 0;

    dt, dd {
      padding: 15px 20px;
      &.same-group {
        margin-top: -5px;
        padding-top: 0;
      }
    }

    dt {
      color: #707070;
      font-family: "Sansation Bold", Serif;
      font-size: 16px;
    }

    dd {
      color: #43425d;
      font-family: "Avenir Roman";
      font-size: 16px;
    }
  }
}
</style>
